import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Control, actions } from 'react-redux-form/immutable'
import Trash from 'react-icons/lib/md/delete'
import trim from 'validator/lib/trim'

import SearchModal from 'components/SearchModal'

class ListFeeItem extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openSearch: false,
      feesFiltered: props.__fees,
    }
  }

  _showSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _hideSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  // F10 - keyCode = 121
  _onKeyDown = (e) => {
    if (e.keyCode === 121) {
      // show search
      this._showSearch()
    }
    if (e.keyCode === 13) {
      // search directly
      const value = trim(e.target.value)
      this.props.onBlur(value, this.props.k)
      e.preventDefault()
    }
  }

  _resetFee() {
    const { dispatch, k } = this.props
    dispatch(actions.change(`paymentState.fees[${k}].fee_id`, 0))
    dispatch(actions.change(`paymentState.fees[${k}].fee_code`, ''))
    dispatch(actions.change(`paymentState.fees[${k}].fee_name`, ''))
    dispatch(actions.change(`paymentState.fees[${k}].acct_code`, ''))
  }

  _onBlur = (e) => {
    if (!e.target.value) {
      this._resetFee()
      return false
    }

    const res = this._searchFee(e.target.value)
    if (res.size === 0) {
      this._resetFee()
      return false
    } else {
      this._onSelectFee(res.get(0))
    }
  }

  _onDelete = () => {
    this.props.dispatch(actions.remove('paymentState.fees', this.props.k))
  }

  _searchFee(term) {
    const { __fees } = this.props

    const regex = new RegExp(term, 'i')
    const filtered = __fees.filter((item) => item.get('code').search(regex) > -1)

    return filtered
  }

  _onSearchFee = (term) => {
    this.setState({
      feesFiltered: this._searchFee(term),
    })
  }

  _onSelectFee = (fee) => {
    const { dispatch, k, item } = this.props
    console.log(this.props)
    const newItem = item
      .set('fee_id', fee.get('id'))
      .set('fee_code', fee.get('code'))
      .set('fee_name', fee.get('name'))
      .set('acct_code', fee.get('acct_code'))
    dispatch(actions.change(`paymentState.fees[${k}]`, newItem))
    this._hideSearch()
    dispatch(actions.focus(`paymentState.fees[${k}].amount`))
  }

  _renderSearch() {
    const { openSearch, feesFiltered } = this.state

    if (!openSearch) {
      return null
    }

    return (
      <SearchModal
        placeholder="Search Fee Code"
        handleClose={this._hideSearch}
        results={feesFiltered}
        onSubmit={this._onSearchFee}
        onSelectItem={this._onSelectFee}
      />
    )
  }

  render() {
    const { item, isShow, k } = this.props
    const trClass = item.get('fee_id') ? '' : 'blank'
    return (
      <tr className={trClass}>
        <td>{!isShow && <button type="button" onClick={this._onDelete} className="btn-inline btn-icon"><Trash /></button>}</td>
        <td>
          <Control.text
            model={`.fees[${k}].fee_code`}
            onKeyDown={this._onKeyDown}
            onBlur={this._onBlur}
          />
        </td>
        <td>{item.get('fee_name')}</td>
        <td className="text-right">
          {item.get('acct_code')}
          {this._renderSearch()}
        </td>
        <td className="text-right">
          <Control.text
            model={`.fees[${k}].amount`}
            className="amount"
          />
        </td>
      </tr>
    )
  }
}

function mapStateToProps(state) {
  return {
    __fees: state.fee.get('items'),
  }
}
export default connect(mapStateToProps)(ListFeeItem)



// WEBPACK FOOTER //
// ./src/containers/Payments/list-fee-item.js